import React from 'react'
import { Button, Tooltip } from 'antd'
import { HomeOutlined, CloseOutlined, ExportOutlined } from '@ant-design/icons'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'

interface DocsDrawerNavbarProps {
  title?: React.ReactNode
  isLoading?: boolean
  showHomeButton?: boolean
  showOpenInNewTab?: boolean
  homeTooltip?: React.ReactNode
  onHomeNavigation?: () => void
  onOpenInNewTab?: () => void
  onClose: () => void
  disableOpenInNewTab?: boolean
  forceLightTheme?: boolean
}

export const DocsDrawerNavbar: React.FC<DocsDrawerNavbarProps> = ({
  title,
  isLoading = false,
  showHomeButton = true,
  showOpenInNewTab = false,
  homeTooltip,
  onHomeNavigation,
  onOpenInNewTab,
  onClose,
  disableOpenInNewTab = false,
  forceLightTheme = false,
}) => {
  return (
    <div
      className={`drawer-navbar-header${forceLightTheme ? ' force-light-theme' : ''}`}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {showHomeButton && onHomeNavigation && (
          <Tooltip title={homeTooltip || <IntlMessages id="app.goToDashboard" />}>
            <Button
              type="text"
              icon={<HomeOutlined />}
              onClick={onHomeNavigation}
              size="small"
              disabled={isLoading}
            />
          </Tooltip>
        )}
        {title && (
          <span style={{ fontWeight: 500, fontSize: '16px' }}>
            {title}
          </span>
        )}
        {isLoading && (
          <span style={{ fontSize: '12px', color: '#666' }}>Loading...</span>
        )}
      </div>

      <div style={{ display: 'flex', gap: '4px' }}>
        {showOpenInNewTab && onOpenInNewTab && (
          <Tooltip title={<IntlMessages id="app.openInNewTab" />}>
            <Button
              type="text"
              icon={<ExportOutlined />}
              onClick={onOpenInNewTab}
              size="small"
              disabled={disableOpenInNewTab || isLoading}
            >
              <IntlMessages id="app.openInNewTab" />
            </Button>
          </Tooltip>
        )}

        <Tooltip title={<IntlMessages id="app.close" />}>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            size="small"
          />
        </Tooltip>
      </div>
    </div>
  )
}
